export default class lowlayerManager {
    constructor(effect,mouse,param) {

        this.effect = effect;
        this.mouse = mouse;
        this.param = param;

        //object
        this.kvCopy = document.querySelectorAll("#p-kv__content>*");
        this.kvImage = document.querySelectorAll("#p-kv__image>*");
        this.sideNavi = document.querySelectorAll("#side_nav>*");

        this.section = document.querySelectorAll(".p-section.js__sc-point");

        this.status = {
            sideNaviFlg:false
        }

    }
    init(execution,pageID){

        if(execution=="landing"){

            this.effect.showSimple(this.kvCopy,"set");
            this.effect.showSimple(this.sideNavi,"set");
            this.effect.scale(this.kvImage,"set");

            setTimeout(()=>{
                this.effect.scale(this.kvImage,"show");
                setTimeout(()=> {
                    this.effect.showSimple(this.kvCopy,"show");
                    setTimeout(()=> {
                    if(this.section[0].querySelectorAll('.js__tsc-show')) this.effect.show(this.section[0].querySelectorAll('.js__tsc-show'),"show");
                    },10e2);
                    if (this.mouse) {
                        this.mouse.modeChange('small','scroll');
                    }
                },2e2);
            },3e2);

        }else{
        }

    }
    show(){// 画面遷移時に使用
    }
    out(){// 画面遷移時に使用
    }
    render(scrollInc){
        if(this.status.sideNaviFlg) return;
        let _minus = 0.3;
        if(this.param.displayType === 'sp'){
            _minus = 0.1;
        }
        if((document.getElementById('p-kv').clientHeight)*_minus <= scrollInc){
            this.status.sideNaviFlg = true;
            this.effect.showSimple(this.sideNavi,"show");
        }
    }
    resize(displayType){
    }
}